import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectAlternative, alternativeListUpdateSelected } from "../../app/actions/alternativeActions";
import { registerPanelViewInterest } from "../../app/helpers/intentTrackingHelper";
import ReadMoreReadLess from "../generic-read-more/ReadMoreReadLess";
import L5ModalAlternative from "./L5ModalAlternative";
import { debugLogPages } from "../../app/helpers/debugHelper";
import { useTranslation } from "react-i18next";
import SemanticSimilarityBadge from "./SemanticSimilarityBadge";

const L4CardAlternative = ({ data, moduleSelected }) => {
  
  debugLogPages(":: L4CardAlternative");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { comparisonAlternativeCheckEnabled } = useSelector((state) => state.configuration);
  const { numberAlternativeSelected } = useSelector((state) => state.alternative);
  const [checked] = useState(false);
  const [popupInformationTechIsOpen, setPopupInformationTechIsOpen] = useState(false);

  const isChecked = data.isSelected;

  const handleToggle = () => {
      dispatch(alternativeListUpdateSelected(data.id));
    };

  const closeModal = () => {
    setPopupInformationTechIsOpen(false);
  }

  const handleViewAlternative = (e) => {
    e.preventDefault();
    dispatch(selectAlternative(data));
    registerPanelViewInterest(dispatch, 'alternative', data);
    navigate(`/end-user-search/preview-alternative`);
  };

  const PreviewImageShow = () => {
  // Imagen por defecto
  //const defaultImg = "/Modulos/TecBC.png";
  const defaultImg = '/images/logo_teccc_no_disponible.png'

  const handleImgError = (e) => {
    // Si la imagen falla, reemplazamos el src por la de defecto
    e.target.src = defaultImg;
    // Opcional: puedes quitar el atributo onError para evitar bucles si la de defecto también falla
    e.target.onerror = null; 
  };

  if (data.ModuleFile_To_Alternative && data.ModuleFile_To_Alternative.length > 0) {
    return (
      <img 
        src={data.ModuleFile_To_Alternative[0].url} 
        alt="file" 
        onError={handleImgError} // <-- El truco está aquí
      />
    );
  } else {
    return (
      <div>
        <img src={defaultImg} width="300px" alt="technology" />
      </div>
    );
  }
};

  const handlePopupSwall = (e) => {
    e.preventDefault();
    registerPanelViewInterest(dispatch, 'alternative', data);

    setPopupInformationTechIsOpen(true);
  };

  debugLogPages(':: L4CardAlternative', {numberAlternativeSelected:numberAlternativeSelected});

  return (
    <li className="cards__item">
      <div className="card"
      >
        {comparisonAlternativeCheckEnabled === "true" && <div>
          <label>
            <input
              type="checkbox"
              checked={isChecked} 
              onChange={handleToggle}
            />
            <div className="espacioComparar">{checked ? `${t('general.card-selected')}` : `${t('general.card-select')}`}</div>
          </label>
        </div>}
        <div className="card__image" onClick={handlePopupSwall}>
          <PreviewImageShow />
        </div>
        <div className="card__content">
          <SemanticSimilarityBadge data={data} moduleKey="alternative" />
          <div className="card__title">
            <ReadMoreReadLess
              className='read-more-less'
              buttonClassName='btn-read-more-less'
              expandLabel="Leer más" 
              collapseLabel="Leer menos" 
              limit={100}
            >
              {data && data.name}
            </ReadMoreReadLess>
          </div>
          <br />
          <div className="card__text">
            <ReadMoreReadLess
              className='read-more-less'
              buttonClassName='btn-read-more-less'
              expandLabel="Leer más" 
              collapseLabel="Leer menos" 
              limit={100}
            >
              {data && data.purpose}
            </ReadMoreReadLess>
          </div>
          <button className="btn btn--block button-color-view" onClick={handleViewAlternative}>
            {t("buttons.view")}
          </button>
        </div>
      </div>

      <L5ModalAlternative
        modalIsOpen={popupInformationTechIsOpen}
        closeModal={closeModal}
        data={data}
        moduleSelected={moduleSelected}
      />

    </li>
  );
};

export default L4CardAlternative;
